export default "__VITE_ASSET__Wj0rPmis__"